import { t } from "ttag";

import { IsoLogo } from "@/assets";
import {
  DOCUMENT_FOLDER,
  PROVIDER_FOLDER,
  READ_ONLY_DOCUMENT_FOLDER,
} from "@/shared/models/legacy-constants";
import type { DocumentFolder } from "@/shared/models/legacy-types";
import {
  DocumentMedicineIcon,
  FolderCheckIcon,
  MeditationRoundIcon,
  StarRainbowIcon,
  StarsIcon,
  StethoscopeIcon,
  TestTubeIcon,
  TranslateIcon,
} from "@/shared/ui";

const COACHING_SESSION_ICON = {
  [PROVIDER_FOLDER.NUTRITIONAL]: <StarsIcon />,
  [PROVIDER_FOLDER.MINDSET]: <StarRainbowIcon />,
  [PROVIDER_FOLDER.SPANISH]: <TranslateIcon />,
  [PROVIDER_FOLDER.MOVEMENT]: <MeditationRoundIcon />,
} as const;

export const getDropzoneLabel = (folder: DocumentFolder) => {
  const DROPZONE_LABEL = {
    [DOCUMENT_FOLDER.LABS]: t`Lab test here`,
    [DOCUMENT_FOLDER.PRESCRIPTIONS]: t`Previous prescriptions here`,
    [DOCUMENT_FOLDER.OTHER]: t`Medical records here`,
  } as const;

  return DROPZONE_LABEL[folder];
};

export const getDocumentEditNameLabel = (documentFolder: DocumentFolder) => {
  const DOCUMENT_EDIT_NAME_LABEL = {
    [DOCUMENT_FOLDER.LABS]: t`Test name`,
    [DOCUMENT_FOLDER.PRESCRIPTIONS]: t`Prescription name`,
    [DOCUMENT_FOLDER.OTHER]: t`Record name`,
  } as const;

  return DOCUMENT_EDIT_NAME_LABEL[documentFolder];
};

export const getDocumentLabel = (documentFolder: DocumentFolder) => {
  const DOCUMENT_LABEL = {
    [DOCUMENT_FOLDER.LABS]: t`lab tests`,
    [DOCUMENT_FOLDER.PRESCRIPTIONS]: t`prescriptions`,
    [DOCUMENT_FOLDER.OTHER]: t`medical records`,
  } as const;

  return DOCUMENT_LABEL[documentFolder];
};

export const DOCUMENT_ICON = {
  ...COACHING_SESSION_ICON,
  [DOCUMENT_FOLDER.LABS]: <TestTubeIcon />,
  [DOCUMENT_FOLDER.PRESCRIPTIONS]: <StethoscopeIcon />,
  [DOCUMENT_FOLDER.OTHER]: <FolderCheckIcon />,
  [READ_ONLY_DOCUMENT_FOLDER.DOCTOR_NOTES]: <DocumentMedicineIcon />,
  [READ_ONLY_DOCUMENT_FOLDER.LEVELS_RX_RESOURCES]: <IsoLogo />,
} as const;
